<template>
  <div class="GameList">
    <div class="pages-content">
      <div class="pages-about-gywm">
        <div class="pages-partner-gywm-tdgl">
          <h1 style="margin-bottom:100px;margin-top:100px">
            {{$t("GameListTitle")}}
          </h1>
          <!-- 发行游戏 -->
          <h1 class="game-list-name">
            {{$t("Publishing")}}
          </h1>
          <ul class="partner-gywm-rdgl">
            <li
              class="mar-l-20"
              v-for="(val,index) in PublishingData"
              :key="index"
            >
              <a
                :href="val.Link"
                v-lazy:background-image="val.hkImg||val.HoverImg"
                class="Bg publish "
                :class="{'blank':val.Link!='javascript:;'}"
                :target=val.target
              >
              </a>
              <div class="text clearfix">
                <p>
                  <a
                    :href="val.Link"
                    :target=val.target
                    class="game-a-text publish"
                    :class="{'blank':val.Link!='javascript:;'}"
                  >
                    {{val.hkName}}
                  </a>
                </p>
                <p class="partner-a-text-p">
                  {{val.enName}}
                </p>
                <i
                  class="icon"
                  v-for="(item, index) in val.platform"
                  :key="index"
                  :class="item.platformName"
                  @click="toLink(item.platformLink)"
                ></i>
                <!-- <i class="icon xbox"></i>
                <i class="icon win"></i>
                <i class="icon switch"></i> -->

              </div>
            </li>
          </ul>
          <!-- 代理游戏 -->
          <h1 class="game-list-name">
            {{$t("Distribution")}}
          </h1>
          <ul class="partner-gywm-rdgl">
            <li
              class="mar-l-20"
              v-for="(v,i) in DistributionData"
              :key="i"
            >
              <a
                :href="v.Link"
                target="_blank"
                v-lazy:background-image="v.hkImg||v.HoverImg"
                class="Bg"
              >
              </a>
              <div class="text clearfix">
                <p>
                  <a
                    :href="v.Link"
                    target="_blank"
                    class="game-a-text"
                    style="margin-top:0"
                  >
                    {{v.hkName}}
                  </a>
                </p>
                <p class="partner-a-text-p">
                  {{v.enName}}
                </p>
              </div>

            </li>
          </ul>
          <div class="game-booton"><a
              href="https://www.sonkwo.hk/"
              target="_blank"
              :title='$t("GameListMore")'
            >
              {{$t("GameListMore")}}
            </a></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { PublishingData, DistributionData } from './js/GameListData'
export default {
  name: 'GameList',
  data() {
    return {
      // 代理游戏
      PublishingData: '',
      // 发行游戏
      DistributionData: '',
      // msg: "Welcome to Your Vue.js App",
    }
  },
  mounted() {
    // 动态创建script标签并添加到head中
    const script = document.createElement('script')
    script.src = `https://s2.sonkwostatic.cn/ceasia_hk/js/data/GameListData.js?v=${new Date().getTime()}`
    script.onload = () => {
      // eslint-disable-next-line no-undef
      this.PublishingData = PublishingData
      // eslint-disable-next-line no-undef
      this.DistributionData = DistributionData
      // eslint-disable-next-line no-undef
      this.PublishingDataLength = PublishingData.length
    }
    document.head.appendChild(script)
  },
  methods: {
    toLink(link) {
      if (link !== '') {
        window.location = link
      }
    },
  },
  created() {
    // eslint-disable-next-line no-undef
    console.log(' =>-140', this.PublishingData)
    // eslint-disable-next-line no-undef
    if (this.PublishingData !== '') {
      // eslint-disable-next-line no-undef
      PublishingData.forEach((item, index, arr) => {
        if (item.Link === '') {
          // eslint-disable-next-line no-undef
          PublishingData[index].Link = 'javascript:;'
          // console.log(PublishingData[index]);
        }
      })
    }
    var blank = document.getElementsByClassName('blank')
    for (let index = 0; index < blank.length; index++) {
      const element = blank[index]
      element.target = '_blank'
      // element.cursor = "pointer"
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang='sass' scoped>
@import "./style/Game.sass"
</style>



// WEBPACK FOOTER //
// src/components/game/GameContent.vue